var map = {
	"./ages/adult.svg": 612,
	"./ages/old.svg": 613,
	"./ages/teen.svg": 614,
	"./ages/young.svg": 615,
	"./astronaut.svg": 616,
	"./error.svg": 617,
	"./marked-tag.svg": 328,
	"./no-data.svg": 330,
	"./rock.svg": 329,
	"./test_export.jpg": 618,
	"./verified.png": 573,
	"./wave.svg": 327
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1065;